<template>
    <div class="two-tone-layout left-sidebar">
        <div class="equal-content-sidebar">
            <div class="container">
                <div class="sidebar-wrapper ">
                    <aside>
                        <div class="mb-10"></div>
                        <left-search :city-loc="city"/>
                        <div class="mb-20"></div>
                    </aside>
                </div>
                <div class="content-wrapper">
                    <div class="mb-10"></div>
                    <results :roomslength="rooms.length"/>
                    <grid-results :rooms="rooms"/>
                    <pagination :length="rooms.length"/>
                </div>
            </div>
        </div>
        <div class="clear"></div>
    </div>
</template>
<script>
    import axios from 'axios'
    import LeftSearch from "../components/catalogo/leftSearch";
    import Results from "../components/catalogo/results";
    import GridResults from "../components/catalogo/gridResults";
    import Pagination from "../components/catalogo/pagination";

    export default {
        data: function () {
            return {
                result:'',
                rooms: [],
                city: 'Introduce la población',
            }
        },
        watch: {
            '$route.params.city': function () {
                if (this.$route.params.city === undefined)
                    this.getLocation();
                this.getCatalogue();
            }
        },
        methods: {
            getLocation() {
                this.$getLocation({
                    enableHighAccuracy: true,
                    timeout: Infinity,
                    maximumAge: 0
                }).then(coordinates => {
                    this.getCatalogue(coordinates.lat, coordinates.lng);
                    this.getCity(coordinates.lat, coordinates.lng);
                }).catch(err => {
                    this.getCatalogue();
                });
            },
            async getCatalogue(lat, lng) {
                console.log(this.$route.params.city);
                if (this.$route.params.city === undefined) {
                    let url = "";
                    if (lat === undefined || lng === undefined) {
                        url = "https://roomapi.vola.cat/clients/getmeetingrooms";
                        await axios.get(url).then(result => {
                            this.rooms = result.data.roomLst;
                        }).catch(response => {
                            switch (response.response.status) {
                                case 404:
                                    this.rooms = [];
                                    break;
                            }
                        });
                    } else {
                        url = "https://roomapi.vola.cat/clients/getnearrooms/" + lat + "/" + lng + "/120";
                        await axios.get(url).then(result => {
                            this.rooms = result.data.rooms;
                        }).catch(response => {
                            switch (response.response.status) {
                                case 404:
                                    this.rooms = [];
                                    break;
                            }
                        });
                    }

                } else {
                    let url = "https://roomapi.vola.cat/clients/getmeetingroomsbycity/" + this.$route.params.city;
                    await axios.get(url).then(result => {
                        this.rooms = result.data.roomLst;
                    }).catch(response => {
                        switch (response.response.status) {
                            case 404:
                                this.rooms = [];
                                break;
                        }
                    });
                }
            },
            async getCity(lat, lng) {
                let url = "https://maps.googleapis.com/maps/api/geocode/json?latlng=" + lat + "," + lng + "&sensor=true&key=AIzaSyA2Tgqo5TnQXFB5C_SXx54Okvcqd3WdH8Q";
                const productresult = await axios.get(url);
                this.result = Object.freeze(productresult);
                this.city = this.result.data.results[5].formatted_address;
            }
        },
        components: {Pagination, GridResults, Results, LeftSearch},
        created() {
            this.getLocation();
        }
    }
</script>